(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.current = 0;
        this.timer = null;
        this.paused = false;
        this.editorLock = false;
        this.rtl = getComputedStyle(this).direction === 'rtl';
        this.isSlideEffect = this.dataset.effect === 'slide';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
        this.delay = Math.max(2, parseInt(this.dataset.speed, 10) || 5) * 1000;

        this.mq = window.matchMedia('(max-width: 749px)');
        this.onMq = () => this.syncVideos();
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);

        if (this.slides.length < 2) {
          this.syncVideos();
          return;
        }

        const prevBtn = this.querySelector('[data-prev]');
        const nextBtn = this.querySelector('[data-next]');
        if (prevBtn) prevBtn.addEventListener('click', () => { this.prev(); this.restart(); });
        if (nextBtn) nextBtn.addEventListener('click', () => { this.next(); this.restart(); });
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => { this.goTo(parseInt(dot.dataset.dot, 10)); this.restart(); })
        );

        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.pause(); });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.resume(); });
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.pause(); });
        this.addEventListener('focusout', () => this.resume());

        this.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          const forward = (e.key === 'ArrowRight') !== this.rtl;
          forward ? this.next() : this.prev();
          this.restart();
        });

        this.addEventListener('touchstart', (e) => {
          this.tx = e.touches[0].clientX;
          this.ty = e.touches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (this.tx == null) return;
          const dx = e.changedTouches[0].clientX - this.tx;
          const dy = e.changedTouches[0].clientY - this.ty;
          this.tx = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          const forward = this.rtl ? dx > 0 : dx < 0;
          forward ? this.next() : this.prev();
          this.restart();
        }, { passive: true });

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: jump to the slide being edited
        this.onBlockSelect = (e) => {
          const slide = e.target.closest && e.target.closest('.hero__slide');
          if (!slide || !this.contains(slide)) return;
          this.editorLock = true;
          this.stop();
          this.goTo(this.slides.indexOf(slide), true);
        };
        this.onBlockDeselect = (e) => {
          if (!this.contains(e.target)) return;
          this.editorLock = false;
          this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.goTo(0, true);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(index, instant = false) {
        const n = this.slides.length;
        index = ((index % n) + n) % n;
        this.current = index;
        const dir = this.rtl ? -1 : 1;

        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;

          if (this.isSlideEffect) {
            let d = i - index;
            if (n > 2) {
              if (d > n / 2) d -= n;
              if (d < -n / 2) d += n;
            }
            const offset = d * dir;
            const prevOffset = slide.dataset.offset !== undefined ? parseFloat(slide.dataset.offset) : offset;
            slide.style.transition = instant || Math.abs(offset - prevOffset) > 1 ? 'none' : '';
            slide.style.setProperty('--offset', offset);
            slide.dataset.offset = offset;
          }
        });

        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        this.syncVideos();
      }

      next() { this.goTo(this.current + 1); }
      prev() { this.goTo(this.current - 1); }

      syncVideos() {
        this.querySelectorAll('video').forEach((video) => {
          const slide = video.closest('.hero__slide');
          const visible = slide && slide.classList.contains('is-active') && video.offsetParent !== null;
          if (visible) {
            video.muted = true;
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }

      start() {
        if (!this.autoplay || this.slides.length < 2 || this.paused || this.editorLock) return;
        this.stop();
        this.timer = setInterval(() => this.next(), this.delay);
      }
      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
      restart() { this.stop(); this.start(); }
      pause() { this.paused = true; this.stop(); }
      resume() { this.paused = false; this.start(); }
    }
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-reveal')) {
    class BannerReveal extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        const reveal = this.closest('.bn--reveal') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reveal) this.classList.add('is-ready');

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          this.playVisible();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this.playVisible();
            } else {
              this.videos.forEach((v) => v.pause());
            }
          });
        }, { threshold: 0.25 });
        this.observer.observe(this);

        this.mq = window.matchMedia('(max-width: 749px)');
        this.onMq = () => this.playVisible();
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
      }
      playVisible() {
        this.videos.forEach((v) => {
          if (v.offsetParent !== null) {
            v.muted = true;
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            v.pause();
          }
        });
      }
    }
    customElements.define('banner-reveal', BannerReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souq-collection')) {
    class SouqCollection extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 989px)');
        this.onMq = () => this.syncMode();
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        this.onKey = (e) => { if (e.key === 'Escape') this.closeFilters(); };
        document.addEventListener('keydown', this.onKey);
        this.onPop = () => this.load(window.location.href, false);
        window.addEventListener('popstate', this.onPop);
        this.bind();
      }
      disconnectedCallback() {
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('popstate', this.onPop);
        document.body.style.overflow = '';
      }

      bind() {
        this.filters = this.querySelector('[data-filters]');
        this.syncMode();

        this.querySelectorAll('[data-open-filters]').forEach((b) => b.addEventListener('click', () => this.openFilters()));
        this.querySelectorAll('[data-close-filters]').forEach((b) => b.addEventListener('click', () => this.closeFilters()));

        const form = this.querySelector('[data-filter-form]');
        if (form) {
          form.addEventListener('change', (e) => {
            if (e.target.matches('[data-price-input]')) return;
            this.applyForm(form);
          });
          form.querySelectorAll('[data-price-input]').forEach((input) => {
            input.addEventListener('change', () => {
              clearTimeout(this.priceTimer);
              this.priceTimer = setTimeout(() => this.applyForm(form), 400);
            });
          });
          form.addEventListener('submit', (e) => { e.preventDefault(); this.applyForm(form); });
        }

        const sort = this.querySelector('[data-sort]');
        if (sort) {
          sort.addEventListener('change', () => {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sort.value);
            url.searchParams.delete('page');
            this.load(url.toString());
          });
        }

        this.querySelectorAll('[data-filter-link]').forEach((a) => {
          a.addEventListener('click', (e) => {
            e.preventDefault();
            this.load(a.href);
          });
        });
      }

      syncMode() {
        if (!this.filters) return;
        const drawer = this.mq.matches || this.classList.contains('sc--filters-drawer');
        this.filters.classList.toggle('is-drawer', drawer);
        if (!drawer) {
          this.filters.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
      openFilters() {
        if (!this.filters) return;
        this.filters.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      closeFilters() {
        if (!this.filters) return;
        this.filters.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      applyForm(form) {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (value !== '') params.append(key, value);
        });
        const url = `${window.location.pathname}?${params.toString()}`;
        this.load(url);
      }

      async load(url, push = true) {
        const keepOpen = this.filters && this.filters.classList.contains('is-open');
        const target = new URL(url, window.location.origin);
        const fetchUrl = new URL(target);
        fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
        this.classList.add('is-loading');
        try {
          const res = await fetch(fetchUrl.toString());
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`#${this.id} [data-results]`);
          const current = this.querySelector('[data-results]');
          if (!fresh || !current) throw new Error('missing');
          current.replaceWith(fresh);
          if (push) window.history.pushState({}, '', target.toString());
          this.bind();
          if (keepOpen) this.openFilters();
        } catch (e) {
          window.location.href = target.toString();
        } finally {
          this.classList.remove('is-loading');
        }
      }
    }
    customElements.define('souq-collection', SouqCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souq-contact')) {
    class SouqContact extends HTMLElement {
      connectedCallback() {
        if (this.dataset.single !== 'true') return;
        const items = Array.from(this.querySelectorAll('.ct-q'));
        items.forEach((d) => {
          d.addEventListener('toggle', () => {
            if (!d.open) return;
            items.forEach((o) => { if (o !== d) o.open = false; });
          });
        });
      }
    }
    customElements.define('souq-contact', SouqContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souq-footer')) {
    class SouqFooter extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.ft-acc'));
        if (!this.items.length) return;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.sync = () => {
          const fold = this.mq.matches && this.classList.contains('ft--accordion');
          this.items.forEach((d) => {
            if (fold) d.removeAttribute('open');
            else d.setAttribute('open', '');
          });
        };
        this.onToggleClick = (e) => {
          // On desktop the headings are not toggles
          if (!(this.mq.matches && this.classList.contains('ft--accordion'))) e.preventDefault();
        };
        this.items.forEach((d) => d.querySelector('summary').addEventListener('click', this.onToggleClick));
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.sync);
      }
    }
    customElements.define('souq-footer', SouqFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souq-header')) {
    class SouqHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.drawer = this.querySelector('[data-drawer]');
        this.search = this.querySelector('.sh-search');
        this.searchInput = this.querySelector('[data-search-input]');
        this.results = this.querySelector('[data-results]');
        this.burger = this.querySelector('[data-open-drawer]');
        this.searchBtn = this.querySelector('[data-open-search]');
        this.lastY = window.scrollY;

        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          if (this.drawer && this.drawer.classList.contains('is-open')) this.closeDrawer();
          if (this.search && !this.search.hidden) this.closeSearch();
        };
        document.addEventListener('keydown', this.onKey);

        // Drawer
        if (this.burger) this.burger.addEventListener('click', () => this.openDrawer());
        this.querySelectorAll('[data-close-drawer]').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));

        // Search
        if (this.searchBtn) this.searchBtn.addEventListener('click', () => (this.search.hidden ? this.openSearch() : this.closeSearch()));
        this.querySelectorAll('[data-close-search]').forEach((el) => el.addEventListener('click', () => this.closeSearch()));
        this.onDocClick = (e) => {
          if (this.search && !this.search.hidden && !this.contains(e.target)) this.closeSearch();
        };
        document.addEventListener('click', this.onDocClick);
        if (this.searchInput && this.dataset.predictive === 'true') {
          this.searchInput.addEventListener('input', () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.predict(this.searchInput.value.trim()), 250);
          });
        }

        // Sticky + scroll
        this.setOffset();
        this.onResize = () => this.setOffset();
        window.addEventListener('resize', this.onResize);
        this.onScroll = () => this.handleScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.handleScroll();

        // Announcement rotation
        this.startAnnouncements();

        // Keep cart count fresh (works with Dawn's cart events and a generic event)
        this.onCartChange = () => this.refreshCart();
        document.addEventListener('cart:updated', this.onCartChange);
        if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribeCart = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, this.onCartChange);
        }
        this.onPageShow = (e) => { if (e.persisted) this.refreshCart(); };
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('cart:updated', this.onCartChange);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.unsubscribeCart) this.unsubscribeCart();
        clearInterval(this.annTimer);
        document.body.style.overflow = '';
      }

      /* ---- Sticky ---- */
      setOffset() {
        const ann = this.querySelector('[data-ann]');
        const h = ann ? ann.offsetHeight : 0;
        // Announcement scrolls away, main bar stays pinned
        this.section.style.setProperty('--sh-top', -h + 'px');
      }
      handleScroll() {
        const y = window.scrollY;
        this.section.classList.toggle('sh-scrolled', y > 10);
        if (this.dataset.sticky === 'scroll-up') {
          const busy = (this.drawer && this.drawer.classList.contains('is-open')) || (this.search && !this.search.hidden);
          const goingDown = y > this.lastY && y > this.offsetHeight + 80;
          this.section.classList.toggle('sh-hidden', goingDown && !busy);
        }
        this.lastY = y;
      }

      /* ---- Drawer ---- */
      openDrawer() {
        this.closeSearch();
        this.section.classList.remove('sh-hidden');
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        const panel = this.drawer.querySelector('.sh-drawer__panel');
        setTimeout(() => panel && panel.focus(), 50);
      }
      closeDrawer() {
        if (!this.drawer) return;
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (this.burger && this.drawer.contains(document.activeElement)) this.burger.focus();
      }

      /* ---- Search ---- */
      openSearch() {
        if (!this.search) return;
        this.search.hidden = false;
        if (this.searchBtn) this.searchBtn.setAttribute('aria-expanded', 'true');
        setTimeout(() => this.searchInput && this.searchInput.focus(), 30);
      }
      closeSearch() {
        if (!this.search || this.search.hidden) return;
        this.search.hidden = true;
        if (this.searchBtn) this.searchBtn.setAttribute('aria-expanded', 'false');
      }
      formatPrice(value) {
        const currency = window.Shopify && Shopify.currency ? Shopify.currency.active : '';
        const lang = (document.documentElement.lang || 'en') + '-u-nu-latn';
        try {
          return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(parseFloat(value));
        } catch (e) {
          return value + ' ' + currency;
        }
      }
      async predict(q) {
        if (!this.results) return;
        if (q.length < 2) {
          this.results.innerHTML = '';
          return;
        }
        const url = `${this.dataset.searchUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag`;
        try {
          const res = await fetch(url);
          const data = await res.json();
          if (this.searchInput.value.trim() !== q) return;
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          this.results.innerHTML = '';

          if (!products.length) {
            const p = document.createElement('p');
            p.className = 'sh-results__empty';
            p.textContent = this.results.dataset.noResults;
            this.results.appendChild(p);
            return;
          }

          const list = document.createElement('ul');
          list.className = 'sh-results__list';
          products.forEach((prod) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'sh-result';
            a.href = prod.url;

            const src = (prod.featured_image && prod.featured_image.url) || prod.image;
            const img = document.createElement('img');
            img.alt = '';
            img.loading = 'lazy';
            if (src) img.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
            a.appendChild(img);

            const info = document.createElement('div');
            const title = document.createElement('div');
            title.className = 'sh-result__title';
            title.textContent = prod.title;
            const price = document.createElement('div');
            price.className = 'sh-result__price';
            price.textContent = this.formatPrice(prod.price);
            info.append(title, price);
            a.appendChild(info);

            li.appendChild(a);
            list.appendChild(li);
          });
          this.results.appendChild(list);

          const all = document.createElement('a');
          all.className = 'sh-results__all';
          all.href = `${window.routes && window.routes.search_url ? window.routes.search_url : '/search'}?type=product&q=${encodeURIComponent(q)}`;
          all.textContent = this.results.dataset.viewAll;
          this.results.appendChild(all);
        } catch (e) {
          this.results.innerHTML = '';
        }
      }

      /* ---- Announcement ---- */
      startAnnouncements() {
        const msgs = Array.from(this.querySelectorAll('.sh-ann__msg'));
        const speed = (parseInt(this.dataset.rotate, 10) || 4) * 1000;
        if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let i = 0;
        const show = (n) => msgs.forEach((m, k) => {
          m.classList.toggle('is-active', k === n);
          m.setAttribute('aria-hidden', k === n ? 'false' : 'true');
        });
        this.annTimer = setInterval(() => { i = (i + 1) % msgs.length; show(i); }, speed);
        document.addEventListener('shopify:block:select', (e) => {
          const idx = msgs.indexOf(e.target);
          if (idx < 0) return;
          clearInterval(this.annTimer);
          i = idx;
          show(i);
        });
      }

      /* ---- Cart ---- */
      async refreshCart() {
        const badge = this.querySelector('[data-cart-count]');
        if (!badge) return;
        try {
          const res = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          const cart = await res.json();
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        } catch (e) {}
      }
    }
    customElements.define('souq-header', SouqHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souq-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souq-product')) {
    class SouqProduct extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.sp__slide'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.dots = Array.from(this.querySelectorAll('.sp__dot'));
        this.form = document.getElementById(this.dataset.formId);
        this.variantInput = this.querySelector('[data-variant-input]');
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
        try {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.initGallery();
        this.initZoom();
        this.initVariants();
        this.initQuantity();
        this.initSticky();
      }

      disconnectedCallback() {
        if (this.stickyObserver) this.stickyObserver.disconnect();
      }

      /* ---------- Gallery ---------- */
      initGallery() {
        if (!this.track || this.slides.length < 2) return;
        this.current = 0;
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.goTo(this.current - 1));
        if (next) next.addEventListener('click', () => this.goTo(this.current + 1));
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.current) this.setActive(i);
          });
        }, { passive: true });
      }
      goTo(i) {
        const n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
      }
      setActive(i) {
        this.current = i;
        this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        this.slides.forEach((s, k) => {
          if (k !== i) s.querySelectorAll('video').forEach((v) => v.pause());
        });
        const thumb = this.thumbs[i];
        if (thumb && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) {
          thumb.parentElement.scrollTo({ left: thumb.offsetLeft - 16, behavior: 'smooth' });
        }
      }
      goToMedia(mediaId) {
        const idx = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (idx > -1) this.goTo(idx);
      }

      initZoom() {
        if (!this.closest('.sp--zoom')) return;
        this.querySelectorAll('.sp__zoom').forEach((box) => {
          const img = box.querySelector('img');
          if (!img) return;
          box.addEventListener('mousemove', (e) => {
            const r = box.getBoundingClientRect();
            img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          });
          box.addEventListener('mouseleave', () => { img.style.transformOrigin = ''; });
        });
      }

      /* ---------- Variants ---------- */
      initVariants() {
        this.optionInputs = Array.from(this.querySelectorAll('[data-option]'));
        if (!this.optionInputs.length) return;
        this.optionInputs.forEach((el) => el.addEventListener('change', () => this.onOptionChange()));
        this.markUnavailable();
      }
      selectedOptions() {
        const values = [];
        this.optionInputs.forEach((el) => {
          const i = parseInt(el.dataset.option, 10);
          if (el.tagName === 'SELECT') values[i] = el.value;
          else if (el.checked) values[i] = el.value;
        });
        return values;
      }
      onOptionChange() {
        const values = this.selectedOptions();
        values.forEach((v, i) => {
          const label = this.querySelector(`[data-option-label="${i}"]`);
          if (label) label.textContent = v;
        });
        const variant = this.variants.find((v) => v.options.every((o, i) => o === values[i]));
        this.updateVariant(variant);
        this.markUnavailable();
      }
      markUnavailable() {
        const values = this.selectedOptions();
        this.optionInputs.forEach((el) => {
          if (el.tagName === 'SELECT' || el.type !== 'radio') return;
          const i = parseInt(el.dataset.option, 10);
          const test = values.slice();
          test[i] = el.value;
          const ok = this.variants.some((v) => v.available && v.options.every((o, k) => o === test[k]));
          el.classList.toggle('is-unavailable', !ok);
        });
      }
      updateVariant(variant) {
        const buttons = Array.from(this.querySelectorAll('[data-main-btn], [data-cart-btn]'));
        const buy = this.querySelector('.sp-buy');

        if (!variant) {
          buttons.forEach((b) => {
            b.disabled = true;
            const l = b.querySelector('[data-btn-label]');
            if (l && buy) l.textContent = buy.dataset.unavailable;
          });
          return;
        }

        if (this.variantInput) this.variantInput.value = variant.id;

        buttons.forEach((b) => {
          b.disabled = !variant.available;
          const l = b.querySelector('[data-btn-label]');
          if (l) l.textContent = variant.available ? b.dataset.label : (buy ? buy.dataset.soldout : '');
        });

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const off = onSale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;

        this.querySelectorAll('[data-price], [data-sticky-price]').forEach((el) => { el.textContent = this.formatMoney(variant.price); });
        this.querySelectorAll('[data-compare]').forEach((el) => {
          el.hidden = !onSale;
          if (onSale) el.textContent = this.formatMoney(variant.compare_at_price);
        });
        this.querySelectorAll('[data-badge]').forEach((el) => {
          el.hidden = !onSale;
          if (onSale) el.textContent = el.dataset.label.replace('[percent]', off);
        });
        this.querySelectorAll('[data-save]').forEach((el) => {
          el.hidden = !onSale;
          if (onSale) el.textContent = el.dataset.label.replace('[amount]', this.formatMoney(variant.compare_at_price - variant.price));
        });
        this.querySelectorAll('[data-gallery-badge]').forEach((el) => {
          el.hidden = !onSale;
          if (onSale) el.textContent = `-${off}%`;
        });

        if (variant.featured_media) this.goToMedia(variant.featured_media.id);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      formatMoney(cents) {
        const value = (cents || 0) / 100;
        const fmt = (decimals, thousands = ',', dec = '.') => {
          const parts = value.toFixed(decimals).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts.join(dec);
        };
        const map = {
          amount: fmt(2),
          amount_no_decimals: fmt(0),
          amount_with_comma_separator: fmt(2, '.', ','),
          amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
          amount_with_apostrophe_separator: fmt(2, "'", '.'),
          amount_with_space_separator: fmt(2, ' ', ','),
        };
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (key in map ? map[key] : fmt(2)));
      }

      /* ---------- Quantity ---------- */
      initQuantity() {
        const input = this.querySelector('[data-qty-input]');
        if (!input) return;
        this.querySelectorAll('[data-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
            input.value = v;
          });
        });
      }

      /* ---------- Sticky bar ---------- */
      initSticky() {
        const bar = this.querySelector('[data-sticky-bar]');
        const mainBtn = this.querySelector('[data-main-btn]') || this.querySelector('[data-cart-btn]');
        if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
        if (this.dataset.sticky === 'mobile') bar.setAttribute('data-device', 'mobile');

        const stickyBtn = bar.querySelector('[data-sticky-btn]');
        stickyBtn.addEventListener('click', () => {
          if (mainBtn.disabled) {
            mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (this.form.requestSubmit) this.form.requestSubmit(mainBtn);
          else mainBtn.click();
        });

        this.stickyObserver = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          stickyBtn.tabIndex = show ? 0 : -1;
        });
        this.stickyObserver.observe(mainBtn);
      }
    }
    customElements.define('souq-product', SouqProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
